<script lang="ts">
    export let dismiss: (() => void | undefined);
    export let size: "small" | "medium" | "large" | "extra-large" = "medium";
</script>

<div class="modal" on:click|self={() => dismiss?.()}>
    <div class="modalcontent ui segment" class:small={size === "small"} class:medium={size === "medium"} class:large={size === "large"} class:extra-large={size === "extra-large"}>
        <slot></slot>
    </div>
</div>

<style>
    .modal {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        padding: 1rem;
        box-sizing: border-box;
        backdrop-filter: blur(2px);
    }

    .modalcontent {
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        max-height: 80vh;
        overflow-y: auto;
        position: relative;
        animation: modalSlideIn 0.3s ease-out;
        margin-top: 60px; /* Add margin to avoid top bar */
        width: 100%;
        color: #333; /* Texto oscuro para contraste */
    }

    /* Size variants */
    .modalcontent.small {
        max-width: 25%;
    }

    .modalcontent.medium {
        max-width: 30%;
    }

    .modalcontent.large {
        max-width: 50%;
    }

    .modalcontent.extra-large {
        max-width: 70%;
    }

    @keyframes modalSlideIn {
        from {
            opacity: 0;
            transform: translateY(-20px) scale(0.95);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    /* Large screens (1200px and up) */
    @media (min-width: 1200px) {
        .modal {
            padding: 2rem;
        }

        .modalcontent {
            max-height: 75vh;
        }

        .modalcontent.small {
            max-width: 20%;
        }

        .modalcontent.medium {
            max-width: 25%;
        }

        .modalcontent.large {
            max-width: 45%;
        }

        .modalcontent.extra-large {
            max-width: 65%;
        }
    }

    /* Medium screens (768px to 1199px) */
    @media (min-width: 768px) and (max-width: 1199px) {
        .modal {
            padding: 1.5rem;
        }

        .modalcontent {
            max-height: 80vh;
        }

        .modalcontent.small {
            max-width: 35%;
        }

        .modalcontent.medium {
            max-width: 40%;
        }

        .modalcontent.large {
            max-width: 60%;
        }

        .modalcontent.extra-large {
            max-width: 80%;
        }
    }

    /* Tablet styles (768px to 1024px) */
    @media (min-width: 768px) and (max-width: 1024px) {
        .modal {
            padding: 1rem;
            align-items: flex-start;
            padding-top: 2rem;
        }

        .modalcontent {
            max-width: 70%;
            max-height: 80vh;
            width: 100%;
            margin: 0;
            border-radius: 6px;
            margin-top: 0;
        }
    }

    /* Mobile responsive styles */
    @media (max-width: 767px) {
        .modal {
            padding: 0.5rem;
            align-items: flex-start;
            padding-top: 3rem; /* Increase top padding to avoid header */
        }

        .modalcontent {
            max-width: 95%;
            max-height: 85vh; /* Reduce height to ensure it fits */
            width: 100%;
            margin: 0;
            border-radius: 6px;
            margin-top: 0; /* Remove margin on mobile since we use padding-top */
        }
    }

    /* Small mobile devices */
    @media (max-width: 480px) {
        .modal {
            padding: 0.25rem;
            padding-top: 2rem; /* Adjust for smaller screens */
        }

        .modalcontent {
            max-width: 98%;
            max-height: 90vh;
            border-radius: 4px;
        }
    }

    /* Extra small mobile devices */
    @media (max-width: 360px) {
        .modal {
            padding: 0.1rem;
            padding-top: 1.5rem;
        }

        .modalcontent {
            max-width: 99%;
            max-height: 92vh;
            border-radius: 3px;
        }
    }

    /* Landscape orientation adjustments */
    @media (max-height: 500px) and (orientation: landscape) {
        .modal {
            padding: 0.5rem;
            align-items: flex-start;
            padding-top: 1rem;
        }

        .modalcontent {
            max-height: 95vh;
            margin-top: 0;
        }
    }

    /* High DPI displays */
    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
        .modalcontent {
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        }
    }

    /* Print styles */
    @media print {
        .modal {
            position: static;
            background: white;
            padding: 0;
        }

        .modalcontent {
            max-width: 100%;
            max-height: none;
            box-shadow: none;
            border: 1px solid #ccc;
        }
    }

    /* Accessibility improvements */
    @media (prefers-reduced-motion: reduce) {
        .modalcontent {
            animation: none;
        }
    }

    /* Dark mode support - Override to always use light theme */
    @media (prefers-color-scheme: dark) {
        .modalcontent {
            background: white;
            color: #333;
        }
    }
</style>